import api from "./client";

export const debugAPI = {
  getCallDebug: async (callId) => {
    const response = await api.get(`/api/v1/debug/calls/${callId}`);
    return response.data;
  },

  getRunDebug: async (runId) => {
    const response = await api.get(`/api/v1/debug/runs/${runId}`);
    return response.data;
  },
};
